module.exports = __webpack_public_path__ + "img/contactWechat.d3b4c8af.jpg";